export default {
      id: "btn_apple-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite.svg#btn_apple",
      toString: function () {
        return this.url;
      }
    }